VP = window.VP || {};

/*
 * Page Load Modifers
*/

(function ($) {
  VP.modifiers = {

    pbplayers: [],
    elemwatch: null,
    gscmobilefixed: false,
    runonce:true,
    init: function () {
      var _this = this;


      _this.initiframeholder();
      _this.initotherlocs();
      _this.inityouvisit();
      _this.initbuttonsets();
      _this.initlinktracking();
      _this.inituwlabelfix();
      _this.initlistcols();
      _this.initnavclasses();
      _this.initmediacenternavfix();
      _this.initmobilegscfix();
      _this.hashCheck();
      _this.initbuttonimg();
      _this.fixheadheight();
      _this.initpodbean();
      _this.initpodcasticon();
      _this.initculinaryagents();
      _this.initmediacentersocial();
      _this.initnavtracking();
      _this.bookingwidgetconv();
      _this.audioeyeconv();
      _this.clickevents();
      _this.twocolheaders();
      //_this.relatedfirst(); // delayed
      _this.customlangswitcher();
      _this.shareshow();
      _this.aboutoverlay();
      _this.klaviyoFormPolling();


      // if redirect, fire Optinmonster init immediately
      if ("uwishunudotcom" == VP.helpers.getQParams("redirect") || (window.omnodelay == true)) {
        VP.modifiers.initOM();
      }
      else {
        VP.documentEvents.onDelayInit(VP.modifiers.initOM);
      }
      VP.documentEvents.onDelayInit(VP.modifiers.initOpenTable);


      VP.documentEvents.onDelayInit(VP.modifiers.relatedfirst);

      VP.documentEvents.onResize(_this.onResize.bind(_this), true);
      _this.onResize();
    },
    klaviyoFormPolling: function () {
        const targets = document.querySelectorAll('[class^="klaviyo-form-"]');
        
        if (!targets.length) return;

        console.log("[klaviyoFormPolling]");
        targets.forEach(form => {
            const formId = Array.from(form.classList)
            .find(cls => cls.startsWith('klaviyo-form-'))
            ?.replace('klaviyo-form-', '') || 'unknown';

            let alreadyFired = false;

            const interval = setInterval(() => {
                // Only run if we haven't fired yet
                if (alreadyFired) return;

                const text = form.innerText || '';
                const normalized = text.replace(/\s+/g, ' ').toLowerCase();

                if (normalized.includes('thank you for subscribing')) {
                    alreadyFired = true;
                    clearInterval(interval);

                    VP.helpers.firecustomGTMEvent('klaviyoConvert' + formId);
                    console.log('[VP] klaviyoConvert fired for form:', formId);
                }
            }, 200); 

            // Optional: stop polling after 30s
           // setTimeout(() => clearInterval(interval), 30000);
        });
    },


    aboutoverlay: function() {
        
        var _this = this;
        var $itemswithoverlay = $(".vp-module__imagegrid-item.hasoverlay");
        var $overlayboxes = $(".vp-module__imagegrid-overlay");
        if (!$itemswithoverlay.length) {
            return;
        }
        // console.log("[init aboutoverlay]");

        // hide overlays if non-overlay item is clicked
        $(".vp-module__imagegrid-item.nooverlay").on("click", function (e) {
          
            $(".openitem").removeClass("openitem");
            $(".overlayopen").removeClass("overlayopen");
            $(".vp-module__imagegrid-overlay.open").removeClass("open").slideUp();            
            return;
        })
        _this.aboutoverlayresize();

        $itemswithoverlay.each(function() {
            var $this = $(this);
            $this.on("click", function (e) {
                e.stopPropagation();
                e.preventDefault();

                var _itemnum = $this.data("item");
                var $overlay = $("[data-overlay="+_itemnum+"]");

                if ($overlay.hasClass("open")) {
                    $this.removeClass("openitem");
                    $overlay.parent().removeClass("overlayopen");
                    $overlay.removeClass("open").slideUp();
                    return;
                }
            
                $itemswithoverlay.removeClass("openitem");
                $overlayboxes.removeClass("open");
                $overlayboxes.slideUp();
                $overlay.addClass("open");
                $this.addClass("openitem");
                $overlay.parent().addClass("overlayopen");
                $overlay.slideDown();                               
            });
        })

    },

    aboutoverlayresize: function() {
        // position boxes to display below the current row, which varies depending on breakpoint
        var $itemswithoverlay = $(".vp-module__imagegrid-item.hasoverlay");
        var $overlayboxes = $(".vp-module__imagegrid-overlay");
        if (!$itemswithoverlay.length) {
            return;
        }

        $itemswithoverlay.each(function() {
            var $this = $(this);
            var _itemnum = $this.data("item");
            var $overlay = $("[data-overlay="+_itemnum+"]");

            var _widthpercent = Math.round($this.parent().width() / $this.width());
            if (_widthpercent == 1) {
                $overlay.insertAfter($this);
            }
            else {
                $dataitem = "data-row" + _widthpercent;
                if ($this.attr($dataitem) == "last") {
                    $overlay.insertAfter($this);
                }
                else {
                    var $lastrowitem = $this.nextAll('['+$dataitem+'="last"]').first();
                    $overlay.insertAfter($lastrowitem);
                }
            }
        })
          
    },
    shareshow: function() {
        var _this = this;

        
        var $sharepage = $(".page-share__link");
        var $sharebox = $(".page-share__items");
        var $copybtn = $("#copyButton");
        var $copysts = $("#copyStatus");
        
        if (!$sharepage.length) {
            return;
        }

        // move after print in media center
        var $mcprint = $(".vp-item__print");
        if ($mcprint.length) {
            $(".page-share__holder").insertAfter($mcprint).wrap("<li class='vp-item vp-item__share'/>");
            $(".page-share").remove();
        }


        $sharepage.on("click", function (e) {
            e.stopPropagation();
            e.preventDefault();
            if ($sharebox.hasClass("open")) {
                $sharebox.removeClass("open");
            }
            else {
                $sharebox.addClass("open");
            }
        });
        $sharebox.find("a").on("click", function (e) {
            // close menu when clicked
            $sharebox.removeClass("open");
        });

        $copybtn.on("click", function (e) {
            e.stopPropagation();
            e.preventDefault();

            var _href = window.location.href;
            var _title = $.trim($(this).data("sharetype"));
            VP.helpers.firecustomGTMEvent("socialshareclick",_href,_title);

            var pageURL = window.location.href;
            VP.modifiers.copyToClipboard(pageURL);            
            $copysts.show();

            setTimeout(function() {
                $copysts.hide();
            }, 2000); // Hide the message after 2 seconds
            return false;            
        });        

        $("body").on("click",".shareclick",function() {
            var _href = window.location.href;
            var _title = $.trim($(this).data("sharetype"));
            
            VP.helpers.firecustomGTMEvent("socialshareclick",_href,_title);
        });
        
        
    },
    copyToClipboard: function(text) {
        var textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
    },
    relatedfirst: function() {
        // console.log("[relatedfirst]");
        // move first 3 related items up high on page
        _this = this;
        var $ritems = $(".vp-related-first__panel");
        if (!$ritems.length) {
            return;
        }


        var $rloc = $(".customrelatedloc");

        // Check if the string contains "[related]" using a case-insensitive regular expression
        if ($rloc.length > 0) {          
          $ritems.insertAfter( $rloc.first());
        }
        else {


            var $sitems =  $('.vp-story__item').not('[data-type="breaker"]');
            
            if ($sitems.length > 0) {        
                var _loc = Math.floor($sitems.length / 4) - 1;
                // console.log(_loc);
                if (_loc == 2 || _loc == 6) { // adjust for ad conflict
                    _loc = _loc + 1;
                    // console.log(_loc);
                }
                if (_loc < 0) _loc = 0;
                if (_loc >= $sitems.length) _loc = $sitems.length - 1;    
                // console.log("Placing Related after: " + _loc);
            
                $ritems.insertAfter($sitems[_loc]);
                if ($ritems.find(".vp-wrapper").length == 0) {
                    $ritems.wrapInner("<div class='vp-wrapper'><div class='vp-module vp-article-section'></div></div>");
                }
            }
            else {
                $ritems.appendTo(".vp-intro__content");
            }
        }



        $ritems.show();
        if (_this.runonce) {
            setTimeout(VP.modifiers.relatedfirst, 1000); // run again?? can't find bug that causes this to disappear first time
            _this.runonce = false;
        }
    },
    customlangswitcher: function() {
        var _this = this;
        var $lang = $(".lang");
        var $langlink = $(".lang-link");
        var $langitems = $(".lang-items .tool-item");
        
        if (!$langlink.length) {
            return;
        }
        $langlink.on("click", function (e) {
            e.stopPropagation();
            e.preventDefault();
            if ($lang.hasClass("langopen")) {
                $lang.removeClass("langopen");
            }
            else {
                $lang.addClass("langopen");
            }
        });
        
        $langitems.on("click", function (e) {
            // close menu when clicked
            $lang.removeClass("langopen");
        });
        
            
    },
    initmediacentersocial: function () {
      // manually adjust media center social links due to bug in SWF
      _this = this;

      if (!$(".page-template-page-media-center").length) {
        return;
      }

      // console.log("[initmediacentersocial] adjusting social");

      _currenturl = encodeURIComponent(location.href.split("?")[0].split("#")[0]);
      _fbshare = "https://www.facebook.com/share.php?u=" + _currenturl;
      $(".swp_facebook .swp_share_link").attr("href", _fbshare).attr("data-link", _fbshare);

      _currenttext = encodeURIComponent($("title").first().text());
      _twshare = "https://twitter.com/intent/tweet?text=" + _currenttext + "&url=" + _currenturl
      $(".swp_twitter .swp_share_link").attr("href", _twshare).attr("data-link", _twshare);


    },

    initOM: function () {
      // console.log("[OM] init (queued)");
      if (typeof omloader == "object") {
        $.each(omloader, function (omkey, omfunction) {
          if (typeof omfunction == "function") {
            // console.log("[OM] execute delayed function");
            omfunction();
          }
        });
      }
    },
    initpodcasticon: function () {
      // console.log("[initpodcasticon]");
      $shareitem = $(".nc_tweetContainer.swp_twitter");
      if ($shareitem.length) {
        if ($shareitem.length > 1) {
          $shareitem = $shareitem.first();
        }
        $newitem = $shareitem.clone().appendTo($shareitem.parent());
        $newitem.removeClass("swp_twitter").addClass("swp_podcast");
        $newitem.removeAttr("data-network");
        $newlink = $newitem.find("a");
        $newlink.removeClass("nc_tweet").addClass("nc_podcast");
        $newlink.attr("href", "/features/visit-philly-love-and-grit-podcast/");
        $newlink.removeAttr("target").removeAttr("data-link");
        $newlink.find(".swp_count").remove();
        $newlink.append("<i><span class='screen-reader-text'>Podcast</span></i>");
        // console.log($newitem.length);
        // console.log($newlink.length);
      }
      $(".swp_social_panelSide").fadeIn(300);
    },
    fixheadheight: function () {
      if ($(".js-cinematic-hero.smallalt").length) {
        _minheight = 264;
        _ah = $(".js-cinematic-hero.smallalt").height();
        _hh = $(".vp-cinematic-hero__media-carousel").height();
        if (_hh < _minheight) {
          // console.log("[fixheadheight] adjusting head height: " + _hh);
          $(".js-cinematic-hero.smallalt").height(_ah + _minheight - _hh);
        }
        else {
          // console.log("[fixheadheight] head height ok: " + _hh);
        }
      }
    },
    // extend clickable area to full image on play buttons
    // also add classes to extend the hover effect
    initbuttonimg: function () {
      $(".image-block__image-wrapper").each(function () {
        if ($(this).find(".vp-btn").length) {
          $(this).addClass("button-wrapper");
          $(this).click(function (e) {
            e.stopPropagation();
            e.preventDefault();
            $(this).find(".vp-btn").trigger("click");
          })
        }
      });
    },
    hashCheck: function () {
      // console.log("[modifiers] global hashCheck");
      var _this = this;
      if (window.location.hash != "") {
        var hashlink = window.location.hash.replace("#", "");
        var $hashitem = $("[id='" + hashlink + "']");
        var $quicklinks = $('.vp-quicklinks');
        var $quicklinkswrapper = $('.vp-quicklinks__wrapper');
        if ($hashitem.length == 1) {
          // console.log("[modifiers] global hashCheck, scrolling to item");
          setTimeout(function () {
            _top = $hashitem.offset().top - $("header").height();

            // if there are quicklinks and the link is below quicklinks

            // add double height plus buffer, since there is both a positioning change and an overlap
            // console.log("hash after quicklinks");
            // console.log($hashitem.offset().top);
            // console.log($quicklinkswrapper.offset().top);
            // console.log($hashitem.offset().top > $quicklinkswrapper.offset().top);
            if ($quicklinks.length && $hashitem.offset().top > $quicklinkswrapper.offset().top) {
              _modifier = ($quicklinks.height() * 2 + 15)
              if (VP.helpers.isMobileSize()) {
                _modifier -= 50;
              }
              // console.log("[modifiers] global hashCheck, adding height: " + _modifier);
              _top -= _modifier;
            }

            $("html, body").stop(true, true).animate({ scrollTop: _top + "px" }, 500);
          }, 500);

        }
      }
    },
    initmobilegscfix: function () {
      var _this = this;
      if (window.location.pathname == "/search/" && VP.helpers.isMobile()) {
        $mobstyles = $("link[href*='mobile+en.css']");
        if ($mobstyles.length) {
          //console.log("remove: " + $mobstyles.length);
          $mobstyles.remove();
          _this.gscmobilefixed = true;
        }
        if (!_this.gscmobilefixed) {
          setTimeout(VP.modifiers.initmobilegscfix, 100);
        }
      }
    },
    initmediacenternavfix: function () {
      var _this = this;
      if (window.location.pathname == "/search/" && typeof (tabfilter) == "string" && tabfilter == "tab-media-center") {
        $mctab = $(".tab-media-center");
        if ($mctab.length) {
          if (!$mctab.hasClass("gsc-tabhActive")) {
            $mctab.trigger("click");
          }
        }
        else {
          setTimeout(VP.modifiers.initmediacenternavfix, 500);
        }
      }
    },
    initnavclasses: function () {
      if ($("#menu-header").length) {
        $("body").addClass("nav-primary");
      }
      if ($("#menu-media-center-navigation").length) {
        $("body").addClass("nav-media-center");
      }
      if ($("#menu-partner-navigation-menu").length) {
        $("body").addClass("nav-partner");
      }
    },
    initotherlocs: function () {
      if ((".other-locs").length == 0) return;

      $(".vp-modules").on("click", ".other-locs", function () {
        active = $(this).hasClass("active");
        $items = $(this).parent().siblings(".other-loc-items");
        if (!active) {
          $(this).addClass("active");
          $items.slideDown();
          $(this).find("span").hide();
        }
        else {
          $(this).removeClass("active");
          $items.slideUp();
          $(this).find("span").show();
        }
      });

    },
    initlistcols: function () {
      // NOTE: Function can be used to work with additional number of columns
      var num_cols = 2,
        containerClass = "twocol",
        listItem = 'li',
        listClass = 'sub-list';
      $("ul." + containerClass).each(function () {
        var items_per_col = new Array(),
          items = $(this).find(listItem),
          min_items_per_col = Math.floor(items.length / num_cols),
          difference = items.length - (min_items_per_col * num_cols);
        for (var i = 0; i < num_cols; i++) {
          if (i < difference) {
            items_per_col[i] = min_items_per_col + 1;
          } else {
            items_per_col[i] = min_items_per_col;
          }
        }
        for (var i = 0; i < num_cols; i++) {
          $(this).append($('<div><ul ></ul></div>').addClass(listClass));
          for (var j = 0; j < items_per_col[i]; j++) {
            var pointer = 0;
            for (var k = 0; k < i; k++) {
              pointer += items_per_col[k];
            }
            $(this).find('.' + listClass + " ul").last().append(items[j + pointer]);
          }
        }

        $(this).replaceWith($('<div class=' + containerClass + '>' + this.innerHTML + '</div>'));
      });
    },
    inituwlabelfix: function () {

      $(".vp-content-grid__item-cta-uwishunu").each(function () {
        $title = $(this).siblings(".vp-content-grid__item-title");
        islarge = ($(this).parents(".vp-featured-content-grid__item--large").length > 0);
        if ($title.length == 1 && !islarge) {
          $(this).parent().addClass("desc-cta-uwishunu");
        }
      });

    },
    inityouvisit: function () {
      var _this = this;
      var scripthref = '//www.youvisit.com/tour/Embed/js2';
      // if page contains a.virtualtour_embed AND script tag not included, add it >>
      if ($("a.virtualtour_embed").length > 0 && $("script[src*='" + scripthref + "']").length == 0) {
        VP.helpers.loadScript(scripthref);
        _this.youvisitwatch();
      }
      $('.youvisit_landing_container').addClass('vp-frameholder');
    },
    initOpenTable: function () {
      var _this = this;
      $ot = $(".ot-reservation-widget .ot-form");

      if ($ot.length) {
        $ot.submit(function () {
          _rid = $(this).find("[name='ot-rid']").val();
          _rsize = $(this).find("[name='ot-size']").val();
          _rdate = $(this).find("[name='ot-date']").val();
          _rtime = $(this).find("[name='ot-time']").val();

          _rdatevals = _rdate.split("/");
          if (_rdatevals.length != 3) {
            alert("Please enter a valid date");
            $(this).find("[name='ot-date']").focus();
            return false;
          }

          _rdate = _rdatevals[2] + "-" + _rdatevals[0] + "-" + _rdatevals[1];
          // console.log("submitting " + _rid);
          // console.log(_rsize);
          // console.log(_rdate);
          // console.log(_rtime);

          _rurl = "https://www.opentable.com/restref/client/?rid=" + _rid;
          _rurl += "&restref=" + _rid;
          _rurl += "&partysize=" + _rsize;
          _rurl += "&datetime=" + _rdate + "T" + _rtime;
          _rurl += "&lang=en-US&r3uid=W8w3Ot2vAD&ot_source=visitphilly.com";
          // console.log(_rurl);


          $heading = $(this).parents(".vp-article-section").find(".vp-article-section__heading");
          if ($heading.length == 1) {
            _title = $heading.text();
          }
          else {
            _title = _rid;
          }
          VP.helpers.firecustomGTMEvent("opentableSubmit", $.trim(_title));

          VP.videoModal.showIFrame(_rurl);
          return false;
        });
      }
    },
    initpodbean: function () {
      var _this = this;
      var scripthref = '//pbcdn1.podbean.com/fs1/player/api.js';
      // if page contains a.virtualtour_embed AND script tag not included, add it >>
      if ($('iframe[src*="www.podbean.com"]').length > 0 && $("script[src*='" + scripthref + "']").length == 0) {
        VP.helpers.loadScript(scripthref, VP.modifiers.initpodbeanapi);
      }
      $('iframe[src*="www.podbean.com"]').parent().removeClass('vp-frameholder').addClass('vp-frameholderalt').addClass('vp-framepodbean');

    },
    initculinaryagents: function () {
      var _this = this;
      var scripthref = 'https://widget.culinaryagents.com/js/ca-widgets.1.1.js';
      // if page contains a.virtualtour_embed AND script tag not included, add it >>
      if ($('.ca-widget-jobs').length > 0 && $("script[src*='" + scripthref + "']").length == 0) {

        window.CulinaryAgents = window.CulinaryAgents || {};
        window.CulinaryAgents.ClientId = 'CA-SS-VISITPHILLY20';
        VP.helpers.loadScript(scripthref);
      }

    },
    initpodbeanapi: function () {
      var _this = VP.modifiers;
      // https://developers.podbean.com/apidoc/widget
      $('iframe[src*="www.podbean.com"]').each(function () {
        var _pbframe = $(this).get(0);
        var _pb = new PB(_pbframe);
        var _title = $(_pbframe).attr("title");
        // console.log(_title);
        _pb.bind('PB.Widget.Events.PLAY', function (event) {
          // console.log('[' + _title + ']' + " PLAY", event);
          VP.helpers.firecustomGTMEvent("podcastPlay", _title);
        });
        
        // _pb.bind('PB.Widget.Events.PAUSE', function (event) {
        //     console.log('[' + _title + ']' + " PAUSE", event);
        // });
        // _pb.bind('PB.Widget.Events.FINISH', function (event) {
        //     console.log('[' + _title + ']' + " FINISH", event);
        // });
        
      });
    },
    youvisitwatch: function () {
      console.log("youvisitwatch");
      var _this = this;
      if (_this.elemwatch) {
        clearInterval(_this.elemwatch);
      }
      _this.elemwatch = setInterval(function () {
        var elem = document.activeElement;
        if (elem && elem.tagName.toUpperCase() == 'IFRAME' && elem.className == 'youvisit-embed') {
          clearInterval(_this.elemwatch);
          VP.helpers.firecustomGTMEvent("youvisitclick");
        }
      }, 100);
    },
    bookingwidgetconv: function () {
        // 2024 aRes
        $("body").on("submit", '#aresWidgetGeneral form', function () {
            VP.helpers.firecustomGTMEvent("aresbookingconversiongeneral");
        });

        $("body").on("submit", '#aresWidgetOverlay form', function () {
            VP.helpers.firecustomGTMEvent("aresbookingconversionoverlaygeneral");
        });
        $("body").on("submit", '#aresWidgetVPOP form', function () {
            VP.helpers.firecustomGTMEvent("aresbookingconversionpackage");
        });
        $("body").on("submit", '#aresWidgetVPOPOverlay form', function () {
            VP.helpers.firecustomGTMEvent("aresbookingconversionoverlaypackage");
        });
        

        $("body").on("click", '.aresWidgetDates input', function () {
            VP.helpers.firecustomGTMEvent("aresbookingdates");
        });

        $("body").on("click", '.aresWidgetQtys select', function () {
            VP.helpers.firecustomGTMEvent("aresbookingqtys");
        });

   
        // check when aRes added to body
        var targetNode = document.body; 
        var config = { childList: true, subtree: true }; 
        var callback = function(mutationsList) {
            mutationsList.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                // Loop through added nodes
                $(mutation.addedNodes).each(function() {
  
                    if ($(this).attr('id') === 'aresHotelSearchWidget' || $(this).find('#aresHotelSearchWidget').length > 0) {
                        // Find the element with ID 'aresHotelSearchWidget'
                        var hotelSearchWidget = $(this).attr('id') === 'aresHotelSearchWidget' ? $(this) : $(this).find('#aresHotelSearchWidget');
                        if (hotelSearchWidget.closest('#aresWidgetOverlay').length > 0) {                         
                            VP.helpers.firecustomGTMEvent("aresbookingvisibloverlaygeneral");
                        }  
                        else if (hotelSearchWidget.closest('#aresWidgetVPOPOverlay').length > 0) {                         
                            VP.helpers.firecustomGTMEvent("aresbookingvisibloverlaypackage");
                        }
                                              
                    }
                });
                
            }
            });
        };
        var observer = new MutationObserver(callback);
        observer.observe(targetNode, config);

         // OLD BOOK DIRECT
        $("body").on("click", "button[id^=jrs-button]", function () {
            VP.helpers.firecustomGTMEvent("bookingconversion");
        });
        $("body").on("change", "select[class^=jrs-select]", function () {
            var elabel = $(this).find(":selected").text();
            VP.helpers.firecustomGTMEvent("bookingselect",elabel);
        });
        $("body").on("click", "input[class^=jrs-datepicker]", function () {
            var elabel = $(this).val();        
            VP.helpers.firecustomGTMEvent("bookingdate",elabel);
        });
        $(".newsitem").on("click", function () {
            var elabel = $(this).find("h3").text();        
            VP.helpers.firecustomGTMEvent("clicknewsitem",elabel);
        });
    },
    audioeyeconv: function () {
      $("body").on("click", "#ae_launcher", function () {
        VP.helpers.firecustomGTMEvent("audioeyeclick");
      });
    },
    clickevents: function() {
        
        $("body").on("click",".vp-related-content__link",function() {
            var _href = $.trim($(this).attr("href"));
            var _title = $.trim($(this).find("h3").text());
            var _item = $.trim($(this).data("item"));

            VP.helpers.firecustomGTMEvent("relatedcontentclick",_href,_title,_item);
        });
      

        $("body.visit-philly-love-and-grit-podcast").on("click", ".subscribe", function () {
            VP.helpers.firecustomGTMEvent("converttwitter");
        });

        $("a[data-track]").on("click",function() {
            var _cat = $.trim($(this).data("track"));
            var _label = $.trim($(this).data("label"));
            var _action = $.trim($(this).data("action"));
            VP.helpers.firecustomGTMTrack(_cat,_label,_action);
        });
    },
    initiframeholder: function () {

        $('iframe').each(function() {
            var $iframe = $(this);
            var $parent = $iframe.parent();

            if ($parent.children().length === 1) {  
                $parent.addClass('vp-frameholder');
            } else {
                $iframe.wrap('<div class="vp-frameholder"></div>');
            }
            
        });
        


      $('iframe[src*="www.youtube.com"]').each(function () {
        
        var _w = $(this).width();
        var _h = $(this).height();
        var _pp =  Math.round(_h / _w * 100);
        console.log("[frameratio]",_w,_h,_pp);
        var _frameholder = $(this).parents(".vp-frameholder");
        if (_pp > 120) { // vertical frame
            _frameholder.wrap("<div class='vp-framevert'/>");
        }
        else {
            _frameholder.wrap("<div class='vp-framehorz'/>");

        }
        _frameholder.addClass("vp-frameratio").css("padding-top", _pp + "%");
        $(this).attr('width', null).attr('height', null);
        $(this).css('width', '').css('height', '').css('min-height', '').css('min-width', '');
      });

      $('iframe[src*="www.facebook.com"]').parents(".vp-frameholder").addClass('vp-fixedvideoframe');

    },
    twocolheaders:function () {
        var _this = this;
        // set two col image headers to equal height on desktop, for now just include breakpoints
        var $twocols = $(".two-up.image-column");
       // console.log($twocols.length);
        $twocols.each(function() {
            var $headings = $(this).find(".image-column__heading");
          //  console.log($headings.length);
            $headings.each(function() {
           //     console.log($(this).height());
            });          
        });
    },
    loadresponsive:function () {
        // Simple: for images with class "loadresponsive", copy data-src/srcset/sizes to real attrs
        // based on a single breakpoint. Call this on load and on resize.
        var BREAKPOINT = 815; // px
        var isDesktop = (window.matchMedia ? window.matchMedia('(min-width:' + BREAKPOINT + 'px)').matches : (window.innerWidth >= BREAKPOINT));

        function setFromData($img){
            console.log("[loadresponsive]",$img);
            if (!$img || !$img.length) return;
            // Only set if not already set
            var ds  = $img.attr('data-src');  
            if (ds  && !$img.attr('src'))    $img.attr('src', ds);

            $img.addClass('loaded'); // for css transition
        }

        if (isDesktop) {
            $('img.loadresponsive.desktop').each(function(){ setFromData($(this)); });
        } else {
            $('img.loadresponsive.mobile').each(function(){ setFromData($(this)); });
        }
    },


    onResize: function () {
      var _this = this;

      _this.aboutoverlayresize();
      _this.twocolheaders();
      _this.loadresponsive();
      $(".vp-fixedvideoframe iframe").each(function () {
        var _w = $(this).attr("width");
        var _h = $(this).attr("height");

        if (_w && _h && !isNaN(parseInt(_w)) && !isNaN(parseInt(_h))) {
          if (_w > VP.helpers.window.width()) {
            $(this).parent().addClass("vp-frameratio").css("padding-top", Math.round(_h / _w * 100) + "%");
          }
          else {
            $(this).parent().removeClass("vp-frameratio").css("padding-top", "0");
          }
        }

      });
    },

    initbuttonsets: function () {

      // wrapp all in vp-btns to desinate sets
      $('.vp-intro .vp-wysiwyg p > a.vp-btn, .vp-intro .vp-wysiwyg div > a.vp-btn').each(function () {
        if ($(this).siblings("a.vp-btn").length > 0) {
          var $parent = $(this).parent();
          if (!$parent.hasClass('vp-btns')) {
            $parent.addClass('vp-btns');
          }
        }
      });

      $('.vp-wysiwyg p.vp-btns > a.vp-btn:first-child,.vp-wysiwyg div.vp-btns > a.vp-btn:first-child').each(function () {
        var $set = $(this).siblings("a.vp-btn").addBack();
        var _prev3set = $(this).parent().prev().find(".vp-btnset3").length;

        if ($set.length == 3) {
          $set.wrapAll('<div class="vp-btnset3"/>');
        }
        else if ($set.length == 4) {
          $set.wrapAll('<div class="vp-btnset4"/>');
        }
        else if ($set.length == 2 && _prev3set) { // five set
          $set.wrapAll('<div class="vp-btnset3-2"/>');
        }
        else if ($set.length == 2) {
          $set.wrapAll('<div class="vp-btnset2"/>');
        }
        else {
          for (var i = 0, len = $set.length; i < len; i += 2) {
            $set.slice(i, i + 2).wrapAll('<div class="vp-btnset"/>');
          }
        }
      });



    },

    initlinktracking: function () {
      //  console.log("DEBUG OUTGOING LINKS:")
      // find all A and AREA links to external sites, and enable onclick tacking
      var allLinks = $("A[href^='http'],AREA[href^='http']");  // must start with http (outgoing), but can't link back to visitphilly.com
      allLinks = allLinks.not("[href*='://" + window.location.hostname + "']");
      allLinks = allLinks.not("[href*='://www.visitphilly.com']");
      allLinks = allLinks.not("[href*='://press.visitphilly.com']");
      allLinks = allLinks.not("[href*='://hotels.visitphilly.com']");
      allLinks = allLinks.not("[href$='.pdf']");
      allLinks = allLinks.not("[href$='.mp3']");
      allLinks.each(function (i) {
        //console.log($(this).attr("href"));
        var atarget = $(this).attr("target");
        if (!atarget) {
          // console.log("set target blank for: " + $(this).attr("href"));
          $(this).attr("target", "_blank");
        }
        var arel = $(this).attr("rel");
        if (!arel) {
          // prevent tabnabbing
          $(this).attr("rel", "noopener");
        }
      });
    },
    initnavtracking: function () {
      var _this = $(this);
      // console.log("[initnavtracking]");

      // TOP LEVEL MENU TRACKING
      var $menuitems = $("#menu-header > li.menu-item > a");
      $menuitems.on("click", function () {
        var _haschildren = $(this).parent().hasClass("menu-item-has-children");
        // sub menu open events are included in _nav.js javascript
        if (!_haschildren) {
          var _label = $(this).text();
          VP.helpers.firecustomGTMEvent("mainNav", _label, "Main Menu Click");
        }
      });

      // SUB MENU LIST ITEMS
      $(".sub-menu").each(function () {
        var _stitle = $(this).parents(".menu-item-has-children").find("> a").text();
        var $sublinks = $(this).find("> ul > li > a");
        $sublinks.each(function (i, j) {
          var _num = i + 1;
          $(this).click(function () {
            var _action = _stitle + " | Primary Column Click | " + _num;
            var _label = $(this).text() + " | " + $(this).attr("href");
            VP.helpers.firecustomGTMEvent("mainNav", _label, _action);
          })
        });
      })

      // SETUP CUSTOM DATA :: COULD BE PUT DIRECTLY INTO HTML
      $(".vp-events__featured > ul > li > a:not('.btn')").each(function (i, j) {
        $(this).attr("data-num", i + 1);
      });

      $(".vp-events__what-to-do > ul > li > a:not('.btn')").each(function (i, j) {
        $(this).attr("data-column", "Secondary Column");
      });


      // SUB MENU FEATURE CONTENT LISTINGS
      $(".sub-menu__content").each(function () {
        var _stitle = $(this).parents(".menu-item-has-children").find("> a").text();
        $subfeatures = $(this).find("> ul > li > a:not('.btn'), > div > ul > li > a:not('.btn')");
        $subfeatures.each(function (i, j) {
          var _num = i + 1;

          $(this).click(function () {
            _columnname = "Featured Column";

            if ($(this).data("column")) {
              _columnname = $(this).data("column")
            }

            if ($(this).data("num")) {
              _num = $(this).data("num")
            }

            _action = _stitle + " | " + _columnname + " Click | " + _num;
            _label = $(this).find("h2").text() + " | " + $(this).attr("href");
            VP.helpers.firecustomGTMEvent("mainNav", _label, _action);
          })
        });

      })

      $(".vp-plan-your-trip__cta a").click(function () {

        var _stitle = $(this).parents(".menu-item-has-children").find("> a").text();
        _columnname = "Booking Column";
        _action = _stitle + " | " + _columnname + " Click";
        _label = $(this).text() + " | " + $(this).attr("href");
        VP.helpers.firecustomGTMEvent("mainNav", _label, _action);
      })
      //VP.helpers.firecustomGTMEvent("podcastPlay", _label, _action);

    }

  };
})(jQuery);
